import { render, staticRenderFns } from "./RgHistoryMenuButton.vue?vue&type=template&id=1132da5a&scoped=true&"
import script from "./RgHistoryMenuButton.vue?vue&type=script&lang=js&"
export * from "./RgHistoryMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./RgHistoryMenuButton.vue?vue&type=style&index=0&id=1132da5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132da5a",
  null
  
)

export default component.exports